// Toyo Co-op configuration
import { AppConfig } from './types';
import { coopTheme } from './themes';
import { COOP_GAMES } from './games';

export const coopConfig: AppConfig = {
  // App identity
  appId: 'coop',
  appName: 'Toyo Co-op',
  appTagline: 'Work together, win together',
  
  // Theme
  theme: coopTheme,
  
  // Co-op pack only — Team vs Team co-op games
  games: [...COOP_GAMES],
  
  // Feature flags
  features: {
    voting: true,
    hostPlaying: true,
    settings: true,
  },
  
  // Storage prefix
  storagePrefix: 'toyo-coop',
  
  // SEO and metadata
  seo: {
    title: 'Toyo Co-op - Collaborative Multiplayer Games | coop.toyo.games',
    description: 'Work together to win! Collaborative puzzle games and team vs team co-op games. Perfect for team building, family fun, and cooperative gameplay.',
    keywords: [
      'toyo coop',
      'cooperative games',
      'collaborative games',
      'co-op games',
      'break the code',
      'associations',
      'catch shout catch',
      'house run',
      'one brain',
      'team games',
      'cooperative puzzle',
      'multiplayer co-op',
      'team building games',
      'collaborative gameplay',
      'cooperative gameplay',
      'puzzle games',
      'group games',
      'teamwork games',
    ],
    ogTitle: 'Toyo Co-op - Work together, win together',
    ogDescription: 'Collaborative puzzle games and team vs team co-op games. Perfect for team building and cooperative gameplay!',
    ogImage: '/assets/logo.png',
    ogUrl: 'https://coop.toyo.games',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Toyo Co-op - Work together, win together',
    twitterDescription: 'Collaborative and team co-op games. Perfect for team building!',
    twitterImage: '/assets/logo.png',
  },
};

